var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-loading',{attrs:{"active":!_vm.$slots.default}},[(!_vm.$slots.default)?_c('be-card',{attrs:{"header":"","footer":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_c('div',{staticClass:"text-center lead"},[_vm._v("Lade Daten …")]),_c('div',{attrs:{"slot":"footer"},slot:"footer"})]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }